import { render } from "./SectionCard.vue?vue&type=template&id=7bbcaed8&ts=true"
import script from "./SectionCard.vue?vue&type=script&lang=ts"
export * from "./SectionCard.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/ilink-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__